module.exports = __webpack_public_path__ + "img/grade.70236d30.png";